<script setup>
import { computed } from 'vue';

const props = defineProps({
  widget: {
    type: Object,
    required: true,
  },
});

const title = computed(() => props.widget.props?.title || 'Actions rapides');

const actions = computed(() => {
  if (
    props.widget.props?.actions &&
    Array.isArray(props.widget.props.actions)
  ) {
    return props.widget.props.actions;
  }
  return [
    {
      label: 'Nouvelle conversation',
      icon: 'i-lucide-plus',
      action: 'new_conversation',
    },
    {
      label: 'Nouveau contact',
      icon: 'i-lucide-user-plus',
      action: 'new_contact',
    },
  ];
});

const handleAction = action => {
  // Actions peuvent être gérées ici ou via events
  console.log('Action clicked:', action);
};
</script>

<template>
  <div class="h-full flex flex-col font-inter group">
    <div
      v-if="title"
      class="mb-6 pb-4 border-b border-slate-200 flex items-center justify-between px-1"
    >
      <h3 class="text-sm font-bold text-slate-900 tracking-tight">
        {{ title }}
      </h3>
      <div
        class="flex h-7 w-7 items-center justify-center rounded-lg bg-slate-50 border border-slate-200"
      >
        <span class="i-lucide-zap h-3.5 w-3.5 text-indigo-500" />
      </div>
    </div>
    <div class="flex-1 overflow-auto custom-scrollbar pr-1">
      <div
        v-if="actions.length === 0"
        class="flex flex-col items-center justify-center py-16 text-center"
      >
        <div
          class="flex h-16 w-16 items-center justify-center rounded-2xl border border-slate-100 bg-slate-50 mb-4 shadow-sm"
        >
          <span class="i-lucide-zap h-8 w-8 text-slate-200" />
        </div>
        <span class="text-[13px] font-medium text-slate-400">Aucune action configurée</span>
      </div>
      <div v-else class="grid grid-cols-2 gap-3 pb-4">
        <button
          v-for="(actionItem, index) in actions"
          :key="index"
          class="group/btn relative overflow-hidden rounded-xl border border-slate-100 p-4 text-left transition-all duration-200 hover:border-slate-300 hover:bg-slate-50/50 active:scale-[0.98]"
          @click="handleAction(actionItem.action)"
        >
          <div class="flex flex-col gap-3 relative z-10">
            <div
              class="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg transition-all duration-200 bg-white border border-slate-100 shadow-sm text-slate-400 group-hover/btn:text-slate-900 group-hover/btn:border-slate-200"
            >
              <span
                :class="actionItem.icon || 'i-lucide-zap'"
                class="text-xl transition-transform duration-200 group-hover/btn:scale-105"
              />
            </div>
            <div class="min-w-0">
              <span
                class="block text-[13px] font-bold text-slate-900 transition-colors duration-200 truncate"
              >
                {{ actionItem.label }}
              </span>
            </div>

            <div
              class="absolute top-0 right-0 opacity-0 -translate-x-2 transition-all duration-200 group-hover/btn:opacity-100 group-hover/btn:translate-x-0"
            >
              <span class="i-lucide-arrow-right h-4 w-4 text-slate-400" />
            </div>
          </div>
        </button>
      </div>
    </div>
  </div>
</template>
